export default __webpack_public_path__ + "static/Inground-Pool-Removal-f509a681ff23919a3ffe8fa5ff539b31.jpg";